module.exports = __webpack_public_path__ + "img/less_than.ab95393b.svg";